module.exports = __webpack_public_path__ + "img/myLike.25cc498c.png";